import EmptyState from 'ui/EmptyState';
import Link from 'ui/Link';

import { websiteLinkTo } from '../../utils/routes';

const NoAccessInfo: React.FC = () => (
  <EmptyState
    icon="lock"
    title="No access"
    description="You need to be an organization administrator to configure corporate branding."
    px={0}
    pt={0}
    h="100%"
  >
    <Link href={websiteLinkTo('/teams/manage/')} fontSize="md" isExternal>
      Go to my organization
    </Link>
  </EmptyState>
);

export default NoAccessInfo;
